import { useEffect, useState } from 'react';
import { handleForbiddenResponse } from '../utils/api';

const API_BASE_URL = 'https://tkachev-trade.com/api';
const GENERIC_ERROR = 'Could not load the pairs.';

let cachedPairsResponse = null;
let cachedError = null;
let inflightRequest = null;

const fetchPairs = async () => {
  const token = localStorage.getItem('token');

  if (!token) {
    throw new Error(GENERIC_ERROR);
  }

  const response = await fetch(`${API_BASE_URL}/chart/pairs`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
  });

  if (handleForbiddenResponse(response)) {
    throw new Error(GENERIC_ERROR);
  }

  if (!response.ok) {
    throw new Error(GENERIC_ERROR);
  }

  const json = await response.json();

  if (json.status !== 1 || !json.response) {
    throw new Error(GENERIC_ERROR);
  }

  return json.response;
};

export const usePairs = () => {
  const [state, setState] = useState(() => ({
    data: cachedPairsResponse,
    error: cachedError,
    loading: !cachedPairsResponse && !cachedError,
  }));

  useEffect(() => {
    let isCancelled = false;

    if (cachedPairsResponse || cachedError) {
      setState({
        data: cachedPairsResponse,
        error: cachedError,
        loading: false,
      });
      return;
    }

    if (!inflightRequest) {
      inflightRequest = fetchPairs()
        .then((pairsResponse) => {
          cachedPairsResponse = pairsResponse;
          cachedError = null;
          return pairsResponse;
        })
        .catch((error) => {
          const normalizedError = error instanceof Error ? error : new Error(GENERIC_ERROR);
          cachedError = normalizedError;
          throw normalizedError;
        })
        .finally(() => {
          inflightRequest = null;
        });
    }

    inflightRequest
      .then((pairsResponse) => {
        if (!isCancelled) {
          setState({ data: pairsResponse, error: null, loading: false });
        }
      })
      .catch((error) => {
        if (!isCancelled) {
          setState({ data: null, error, loading: false });
        }
      });

    return () => {
      isCancelled = true;
    };
  }, []);

  return state;
};

export const resetPairsCache = () => {
  cachedPairsResponse = null;
  cachedError = null;
  inflightRequest = null;
};


